const StorageConstant = {
    TOKEN: 'token',
    ROLE_ID: 'role_id',
    USER:'user',
    PROFILE_IMAGE: 'profileImage'
}

export default StorageConstant;

